import React from "react"
import { getCart } from "../../../../stores/CartStateStore"

import CouponForm from "./CouponForm"
import PaymentTypeSelector from "./PaymentTypeSelector"
import WalletForm from "./WalletForm"

export default function PaymentDetailsForm(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { wallet, errors } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let cart = getCart(props.cartState)

  // -------------------------------------

  return (
    <div className="payment-details-form order-step">
      <h4>{I18n.t("payment")}</h4>

      {!!props.wallet?.available_amount_cents && (
        <WalletForm
          cartState={props.cartState}
          wallet={wallet}
          onClick={props.onWalletClick}
          isCashSelected={props.cartState?.paymentMethod?.type == "cash"}
        />
      )}

      {(cart.total > 0 || !wallet || wallet.enabled === false) && (
        <PaymentTypeSelector {...props} wallet={wallet} />
      )}

      <CouponForm {...props} initialErrors={errors} />
    </div>
  )
}
